import { render, staticRenderFns } from "./DeleteQuestionConfirmation.vue?vue&type=template&id=49d2f403"
import script from "./DeleteQuestionConfirmation.vue?vue&type=script&lang=js"
export * from "./DeleteQuestionConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports